import { Router } from 'react-router'
import { Provider } from 'react-redux'
import 'normalize.css/normalize.css'
import 'app/common/fonts/fonts.module.scss'
import 'app/common/fonts/fonts'
import objectFitImages from 'object-fit-images'

import store, { history } from './store'
import './styles/index.scss'

import getRoutes from './pages/routes'

objectFitImages()

// Logout если был невторизованный запрос
// axios.interceptors.response.use(response => response, (error) => {
//   if (error.response && error.response.status === 401) store.dispatch(logout());
//   return Promise.reject(error);
// });

const Application = () => (
  <Provider store={store}>
    <Router history={history} routes={getRoutes()} />
  </Provider>
)

export default Application
